import { Button, Stack } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { DismissButtonProps } from './dismissButton';

type MultipleButtonProps = {
  onAction: () => void;
} & DismissButtonProps;

export function MultipleButtons({ onClose, onAction }: MultipleButtonProps) {
  const { t } = useTranslation('common');
  return (
    // NOTE MIGRATION
    <Stack direction='row' spacing={1}>
      <Button variant='text' size='medium' onClick={onClose}>
        {t('errors.form.toast.dismiss')}
      </Button>
      <Button variant='text' size='medium' onClick={onAction}>
        {t('errors.form.toast.action')}
      </Button>
    </Stack>
  );
}
